import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';

import * as actions from 'actions/snackbar';

const useSnackbar = () => {
  const dispatch = useDispatch();
  return bindActionCreators({ ...actions }, dispatch);
};

export default useSnackbar;
